import b from 'b_';
import React from 'react';

import Text from '../../text/text';

import './lesson-banner-view__badge.scss';

export enum LESSON_BANNER_VIEW_BADGE_THEME {
    BLACK = 'black',
    GREEN = 'green',
}

interface Props {
    text: string;
    theme?: LESSON_BANNER_VIEW_BADGE_THEME;
}

export const LessonBannerViewBadge = React.memo(({ text, theme = LESSON_BANNER_VIEW_BADGE_THEME.BLACK }: Props) => {
    return (
        <div className={b('lesson-banner-view', 'badge', { theme })}>
            <Text size={Text.SIZE.M} weight={Text.WEIGHT.M}>
                {text}
            </Text>
        </div>
    );
});
